import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { IChannelProduct } from '../../interfaces';

interface IChannelProductMappingActionCellRendererParams
  extends ICellRendererParams {
  onCreateSku :(data :IChannelProduct) => void;
  onCreateVariantSku :(data :IChannelProduct) => void;
  onAddAlternateSku :(data :IChannelProduct) => void;
}

@Component({
  selector: 'lum-channel-product-mapping-action-cell-renderer',
  templateUrl: './channel-product-mapping-action-cell-renderer.component.html',
  styleUrls: ['./channel-product-mapping-action-cell-renderer.component.scss'],
})
export class ChannelProductMappingActionCellRendererComponent
  implements ICellRendererAngularComp
{
  params :IChannelProductMappingActionCellRendererParams;
  matTooltip :string = 'Add as Alternate Sku';

  agInit(params :IChannelProductMappingActionCellRendererParams) :void {
    this.params = params;
    this.checkForExistingAlternateSku();
  }

  refresh(params :IChannelProductMappingActionCellRendererParams) :boolean {
    return false;
  }

  onCreateSku() :void {
    this.params.onCreateSku(this.params.data);
  }

  onCreateVariantSku() :void {
    this.params.onCreateVariantSku(this.params.data);
  }

  onAddAlternateSku() :void {
    this.params.onAddAlternateSku(this.params.data);
  }

  private checkForExistingAlternateSku() :void {
    if (this.params?.data?.rfq?.alternateSkus?.length > 0) {
      this.params.data.existingAlternateSku =
        this.params.data.rfq.alternateSkus.find(
          (alternateSku :any) =>
            alternateSku?.alternateSku === this.params?.data?.shopifySku,
        );

      if (this.params.data.existingAlternateSku) {
        this.matTooltip = 'Already added as Alternate Sku';
      }
    }
  }
}
